import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Head from "./Head";

const     Body = () => {
  return (
    <div className="flex">
              <Head />
      <Sidebar />
      <Outlet />
    </div>
  );
};

export default Body;
